import SelloTiempoBitacora from "../Components/SelloTiempoBitacora";
import { EnumEstadoCumplimientoEventoConcesion, EnumEstadoEventoConcesionDesc } from "../../../Utils/Enumeradores/ComunEnum";

const obtenerClaseEstadoAutorizacion = (estado) => {
	switch (estado) {
		case EnumEstadoEventoConcesionDesc.Autorizada:
			return 'bg-success';
		case EnumEstadoEventoConcesionDesc.Pendiente:
			return 'bg-primary';
		case EnumEstadoEventoConcesionDesc.Rechazada:
			return 'bg-danger';
		default:
			return '';
	}
};

const EstadoAutorizacionCell = ({ estado }) => {
	const estados = (estado || '').split('/').map((item) => item.trim()).filter(Boolean);
	const estadoAutorizacion = estados.find((item) => item !== 'Reproceso');
	const tieneReproceso = estados.includes('Reproceso');

	return (
		<span className="bitacora-estado-autorizacion-tags">
			{estadoAutorizacion &&
				<span className={`badge badge--monochromatic ${obtenerClaseEstadoAutorizacion(estadoAutorizacion)}`}>
					{estadoAutorizacion}
				</span>
			}
			{tieneReproceso &&
				<span className="badge badge--monochromatic bg-reproceso">
					Reproceso
				</span>
			}
		</span>
	);
};

export const COLUMNS = [
	{
		Header: 'Área de negocio',
		accessor: 'areaNegocio',
	},	
	{
		Header: 'Descripción',
		accessor: 'descripcion',
	},
	{
		Header: 'Medición',
		accessor: 'medicion',
		Cell: ({ row }) => <div>
			{
				<b>{row.original.medicion}</b>
			}
		</div>
	},
	{
		Header: 'Valor Exigido / U. Medida',
		accessor: 'valor',
	},
	{
		Header: 'Fecha creación',
		accessor: 'fechaCreacion',
		Cell: ({ row }) => <SelloTiempoBitacora data={row.original.fechaCreacion} />
	},
	{
		Header: 'Fecha/Hora medición',
		accessor: 'fechaHoraMedicion',
		Cell: ({ row }) => <SelloTiempoBitacora data={row.original.fechaHoraMedicion} />
	},
	{
		Header: 'Tipo ingreso',
		accessor: 'tipoIngreso',
	},
	{
		Header: 'Estado Autorización IF',
		accessor: 'estado',
		className: 'text-center bitacora-estado-autorizacion-column',
		disabledFilters: true,
		Cell: ({ row }) => <EstadoAutorizacionCell estado={row.original.estado} />
	},
	{
		Header: 'Estado Evento',
		accessor: 'estadoEvento',
		Cell: ({ row }) => <span>{row.original.estadoEvento === true ? EnumEstadoCumplimientoEventoConcesion.Cumpliendo : EnumEstadoCumplimientoEventoConcesion.Incumplieno}</span>
	}
];
